<script setup lang="ts">
import { onMounted } from 'vue'
import { useAppStore } from '@/stores/app'
import ToastStack from '@/components/ToastStack.vue'

const store = useAppStore()
onMounted(() => store.initialize())
</script>

<template>
  <RouterView />
  <ToastStack />
</template>
